exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading{position:fixed;z-index:10}.loading,.loading .wrap{left:0;top:0;bottom:0;right:0}.loading .wrap{background:hsla(0,0%,100%,.8);font-size:60px;color:#000;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;position:absolute}", ""]);

// exports
